var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"page"},[_c('h1',{staticClass:"zzgray",domProps:{"innerHTML":_vm._s(_vm.page.title.rendered)}}),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.page.content.rendered)}})]),_c('Blocks',{attrs:{"blocks":_vm.page.acf.zeile}}),(_vm.page.acf.zeile)?_c('Foot'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }